<template>
	<el-card class="box-card" shadow="never" v-if="setlist.length>0">
		<div slot="header" class="clearfix" v-if="title!=''">
			<span>{{title}}</span>
		</div>
		<div class="inputBox" v-if="!isdetail">
			<el-form-item
				v-if="i.ishidden == 'False'"
				:class="['inputItem', (i.controltype == 'textarea'||
				i.controltype == 'checkbox_group'||i.controltype == 'addedservice_sign-insured'
				||i.controltype == 'combox-input-add'||i.controltype=='combox-textarea')?'col24':
				(colspan!='')? 'col12' :
				(i.controltype == 'combox-input')?'col10':'col8']"
				:label="i.showname"
				label-width="100px"
				v-for="(i, index) in setlist"
				:key="index"
				size="mini"
			>
				<el-input
					v-if="i.controltype == 'text' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					:type="i.controltype"
					v-model="i.value"
					:ref="i.colname"
					:placeholder="i.placeholder"
					@keyup.native="val => enterinput(val, i)"
				></el-input>
				<el-date-picker v-if="i.controltype=='date'&& i.ishidden == 'False'" 
					:ref="i.colname" 
					v-model="i.value"
					:placeholder="i.placeholder"
					type="date"
					:style="{ width: `${i.coltdwidth}px`}"
					size="mini"
					value-format="yyyy-MM-dd"
					@keyup.native="val => enterinput(val, i)"
					@change.native="val => text_change(val, i)"
				></el-date-picker>
				<el-input
					v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					type="text"
					:placeholder="i.placeholder"
					v-model="i.value"
					:ref="i.colname"
					@blur="val => checkinput(val, i)"
					@keyup.native="val => enterinput(val, i)"
					@change.native="val => text_change(val, i)"
				></el-input>
				<el-autocomplete
					:ref="i.colname"
					v-if="i.controltype == 'input_filter'"
					clearable 
					:placeholder="i.placeholder"
					v-model="i.value"
					:fetch-suggestions="
						(queryString, cb) => {
							inputsuggestions(queryString, cb, i);
						}
					"
					:style="{ width: `${i.coltdwidth}px` }"
					value-key="showname"
					:trigger-on-focus="true"
					@clear="clearinput(i)"
					@keyup.native="val => enterinput(val, i)"
					@change.native="val => text_change(val, i)"
					@select="val => select_change(val, i)"
				></el-autocomplete>
				<div v-if="i.controltype == 'disabled_billid' && i.ishidden == 'False'" style="display: inline-block;">
					<el-input
						:style="{ width: `${i.coltdwidth}px`}"
						:type="i.controltype"
						:placeholder="i.placeholder"
						v-model="i.value"
						:ref="i.colname"
						:disabled="i.isedit"
						@blur="val => checkinput(val, i)"
						@keyup.native="val => enterinput(val, i)"
					></el-input><i
					  class="el-icon-edit"
					  @click="editinput(i)"
					  style="cursor:pointer;" v-if="isedit"> 
					</i>
				</div>
				<el-input
					:ref="i.colname"
					v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					:type="i.controltype"
					:placeholder="i.placeholder"
					v-model="i.value"
					class="input-with-search"
					@blur="val => checkinput(val, i)"
					@keyup.native="val => enterinput(val, i)"
					@change.native="val => text_change(val, i)"
				>
					<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index)">
						<span style="padding:15px"><i class="el-icon-search"></i></span>
					</div>
				</el-input>
		
				<el-input
					:ref="i.colname"
					v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
					:type="i.controltype"
					v-model="i.value"
					:placeholder="i.placeholder"
					@keyup.native="val => enterinput(val, i)"
				></el-input>
				<el-select
					:ref="i.colname"
					v-model="i.value"
					filterable
					reserve-keyword
					:clearable="true"
					:loading="loading"
					:placeholder="i.placeholder"
					v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					@change="val => text_change(val, i)"
					@keyup.native="val => enterinput(val, i)"
				>
					<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
				</el-select>
				<el-select
				  v-model="i.value" size="mini"
				  v-if="i.controltype == 'select_multiple' && i.ishidden == 'False'" 
				   multiple
				   filterable
				   :clearable="true"
				   :placeholder="i.placeholder"
				   @change="val => text_change(val, i)"
				   :style="{width: `${i.coltdwidth}px` }"
				   placeholder="">
				 <el-option v-for="item in i.colsource" :key="item.u_account" :label="item.u_account" :value="item.u_account"></el-option>
				 </el-select>
				<el-select
					:ref="i.colname"
					v-model="i.value"
					filterable 
					:clearable="true"
					:placeholder="i.placeholder"
					v-if="i.controltype == 'select' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					@change="val => text_change(val, i)"
					@keyup.native="val => enterinput(val, i)"
					:disabled="orderinfo!=''&&i.colass=='editdisabled'"
				>
					<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.value">{{ opt.title }}</el-option>
				</el-select>
				<el-checkbox
					:ref="i.colname"
					v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
					:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
					:checked="i.coldefault == 1 ? true : false"
					@change="val => setcheck(val, i)"
				></el-checkbox>
				<el-checkbox-group :ref="i.colname" v-model="i.value" 
				v-else-if="i.controltype == 'checkbox_group' && i.ishidden == 'False'" 
				size="mini" :disabled="isdetail">
					<el-checkbox :label="opt.title" v-for="(opt, opti) in i.colsource" :key="opti"></el-checkbox>
				  </el-checkbox-group>
				  <div  v-if="i.controltype == 'addedservice_sign-insured'">
				  	<span v-for="(it,itx) in i.value" :key="itx">
				  		<div v-if="it.d_name == '保价'">
				  			<el-checkbox
				  				style="width:80px"
				  				:ref="it.d_name + '_' + index + '_checked'"
				  				:checked="it.ischecked"
				  				v-model="it.ischecked"
				  				@change="val => checkchange(val, it.d_name + '_' + index, i,index)"
				  			>
				  				{{ it.label }}
				  			</el-checkbox>
				  			<el-input
				  				:style="{
				  					width: `90px`,
				  					marginLeft: `10px`,
				  					display: `${it.ischecked? 'inline-block' : 'none'}`
				  				}"
				  				:ref="it.d_name + '_' + index"
				  				type="text"
				  				v-model="it.factprice"
								:placeholder="it.placeholder"
				  				@keyup.native="val => enterinput(val, i)"
				  			></el-input>
				  			<span style="margin-left:50px" v-if="it.ischecked">{{it.factprice}}</span>
				  		</div>
				  		<label v-else>
				  			<el-checkbox style="width:100px" v-model="it.ischecked" 
							:checked="it.ischecked" @change="val => checkchange(val, it.d_name + '_' + index, i,index,it)">{{ it.label }}</el-checkbox>
				  		</label>
				  	</span>
				  </div>
				  <div v-if="i.controltype == 'input-combox-select' && i.ishidden == 'False'"
					style="display:inline-block;" >
					  <el-input :placeholder="i.placeholder" :ref="i.colname" v-model="i.value" :style="{ width: `${i.coltdwidth}px`}" @keyup.native="val => enterinput(val, i)" ></el-input>
					  <el-select  :placeholder="i.placeholder" v-model="i.value1" :style="{ width: `${i.colformat}px`}" :clearable="true">
					    <el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					  </el-select>
				  </div>
				  <div v-if="i.controltype == 'combox-input-add' && i.ishidden == 'False'">
					  <span v-for="(titem, t) in i.combox" :key="t" style="margin-right:10px;">
					  	<span v-for="(tj, ti) in titem.controlcombox" :key="ti" 
						class="tiji" 
						style="margin-right:5px;"
						>
					  		<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
							<el-input-number :placeholder="tj.placeholder" :min="1" v-if="tj.controltype=='number'" :style="{ width: `${tj.coltdwidth}px`}" v-model="tj.value"></el-input-number>
					  		<el-input :placeholder="tj.placeholder" type="text" v-if="tj.controltype=='text'" :style="{ width: `${tj.coltdwidth}px`}" v-model="tj.value" ></el-input>						
					  		<el-select :placeholder="tj.placeholder" v-if="tj.controltype=='select'" v-model="tj.value" :style="{ width: `${tj.coltdwidth}px`}" :clearable="true" :filterable="true">
					  		  <el-option v-for="(opt, opti) in tj.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
					  		</el-select>
					  	</span>
						<i v-if="t<=(i.combox.length-1)&&t>0" class="el-icon-circle-close" @click="removecombox(i.combox,t)" 
						style="color:#cacaca;font-size:16pt;cursor: pointer;"></i>
					  </span>
					  <i class="el-icon-plus" @click="addcombox(i.combox)" 
					  style="margin-left:10px;font-size:14pt;color: #3177ad;font-weight:bold;cursor: pointer;"></i>
				  </div>
				  <el-input :placeholder="i.placeholder" :ref="i.colname" v-model="i.value" 
				  v-if="i.controltype == 'input-combox-label' && i.ishidden == 'False'"
				   class="input-with-search" :style="{ width: `${i.coltdwidth}px`,display:`inline-flex`}" @keyup.native="val => enterinput(val, i)">
				      <template slot="append">{{i.colass}}</template>
				  </el-input>
				<el-radio  :ref="i.colname" v-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
				<div v-if="i.controltype == 'combox-input'" class="tiji">
					<span v-for="(tj, ti) in i.combox" :key="ti">
						<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
						<el-input :placeholder="tj.placeholder" type="text" v-if="tj.controltype=='text'" :style="{ width: `${tj.coltdwidth}px`}" v-model="tj.value" ></el-input>						
						<el-select :placeholder="tj.placeholder" v-if="tj.controltype=='select'" v-model="tj.value" :style="{ width: `${tj.coltdwidth}px`}" :clearable="true" :filterable="true">
						  <el-option v-for="(opt, opti) in tj.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
						</el-select>
					</span>
				</div>
				<div v-if="i.controltype == 'combox-input-180'" class="tiji">
					<span v-for="(tj, ti) in i.combox" :key="ti">
						<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
						<el-input :placeholder="tj.placeholder" type="text" v-if="tj.controltype=='text'" :style="{ width: `${tj.coltdwidth}px`}" v-model="tj.value" ></el-input>						
						<el-input :placeholder="tj.placeholder" type="textarea" v-if="tj.controltype=='textarea'" v-model="tj.value" ></el-input>
						
						<el-select :placeholder="tj.placeholder" v-if="tj.controltype=='select'" 
						v-model="tj.value" :style="{ width: `${tj.coltdwidth}px`}" :clearable="true" :filterable="true" >
						  <el-option v-for="(opt, opti) in tj.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
						</el-select>
					</span>
				</div>
				<div v-if="i.controltype == 'combox-textarea'" class="tiji">
					<span v-for="(tj, ti) in i.combox" :key="ti">
						<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
						<el-input :placeholder="tj.placeholder" type="textarea" v-if="tj.controltype=='textarea'" v-model="tj.value" ></el-input>
						<el-select :placeholder="tj.placeholder" v-if="tj.controltype=='select'" 
						v-model="tj.value" :style="{ width: `${tj.coltdwidth}px`}" :clearable="true" :filterable="true" >
						  <el-option v-for="(opt, opti) in tj.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
						</el-select>
					</span>
				</div>
				<el-input
					:ref="i.colname+'_'+index"
					v-if="i.controltype == 'readonly_text_group' && i.ishidden == 'False'"
					:style="{ width: `${i.coltdwidth}px` }"
					:readonly="true"
					:type="i.controltype"
					v-model="i.value"
					:placeholder="i.placeholder"
					class="input-with-search"
					@keyup.native="val => enterinput(val, i)"
				>
					<div style="width:30px" slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index)">
						<span style="padding:15px"><i class="el-icon-search"></i></span>
					</div>
				</el-input>
				<el-select
				 :ref="i.colname"
				 v-if="i.controltype == 'selectmul' && i.ishidden == 'False'"
				 :style="{ width: `${i.coltdwidth}px` }"
				 :placeholder="i.placeholder"
				 :readonly="true"
				 v-model="i.value"
				   multiple
				   filterable>
				   <el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.value">{{ opt.title }}</el-option>
				   </el-select>
			</el-form-item>
		</div>
		<div class="inputBox" v-if="isdetail">
			<el-form-item
				v-if="i.ishidden == 'False'"
				:class="['inputItem', (i.controltype == 'textarea'||i.controltype == 'checkbox_group'
				||i.controltype == 'addedservice_sign-insured'||i.controltype == 'combox-input-add')?'col24':(colspan!='')? 'col12':'col8']"
				:label="i.showname"
				label-width="110px"
				v-for="(i, index) in setlist"
				:key="index"
				size="mini"
			>
			<span v-if="i.controltype != 'textarea'&&i.controltype != 'checkbox_group'
			&&i.controltype != 'addedservice_sign-insured'">
				<span v-if="i.controltype.indexOf('combox-input')>-1&&i.controltype!='combox-input-add'">
					<span v-for="(tj, ti) in i.combox" :key="ti">
						<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
						<label v-if="tj.controltype=='text'">{{tj.value}}</label>
						<label v-else style="margin-left:10px;">{{tj.value}}</label>
					</span>
				</span>
				<span v-if="i.controltype=='combox-input-add'">
					<span v-for="(titem, t) in i.combox" :key="t" style="margin-right:5px;">
						<span v-for="(tj, ti) in titem.controlcombox" :key="ti" class="tiji" style="margin-right:5px;">
							<label v-if="tj.showname!=''" style="margin-left:10px">{{ tj.showname }}</label>
							<label v-if="tj.controltype=='text'">{{tj.value}}</label>
							<label v-else style="margin-left:5px;">{{tj.value}}</label>
						</span>
					</span>
				</span>
				<span v-else>
					{{i.value}}
				</span>
			</span>
			<span v-for="(it,itx) in i.value" :key="itx" v-if="i.controltype =='addedservice_sign-insured'">
				<div v-if="it.d_name == '保价'">
					<el-checkbox
						style="width:80px"
						:checked="it.ischecked"
						v-model="it.ischecked"
						:disabled="true"
					>
						{{ it.label }}
					</el-checkbox>
					<span style="margin-left:50px" v-if="it.ischecked">{{it.factprice}}</span>
				</div>
				<label v-else>
					<el-checkbox style="width:150px" v-model="it.ischecked" :disabled="true" :checked="it.ischecked">{{ it.label }}</el-checkbox>
				</label>
			</span>
			<div v-if="i.controltype =='textarea'">
				{{i.value}}
			</div>
			</el-form-item>
		</div>
		<selectitem ref="selectitem" width="360px" @selectitemcallback="selectitemcallback"></selectitem>
	</el-card>
</template>
<script>
import Utils from '../../lib/util.js';
import selectitem from '@/components/tools/selectitem.vue';
export default {
	components: {
		selectitem
	},
	props: {
		item: {
			type: Object,
			default:function(){
				return {
					
				};
			}
		},
		isdetail:{
			type:Boolean,
			default:false
		},
		title:{
			type:String,
			default:''
		},
		colspan:{
			type:String,
			default:''
		}
	},
	data() {
		return{
			setlist:[],
			transportmain_lang:{},
			p_mode:'',
			type:'',
			loading:false,
			orderinfo:'',
			syscol:'',
			isedit:true
		};
	},
	mounted() {
		import('../../static/' + this.$theme + '/style/transport.scss');
	},
	methods:{
		init(param){
			//debugger
			this.orderinfo='';
			this.isedit=true;
			if(param.type!=undefined)
				this.type=param.type;
			if(param.p_mode!=undefined)
				this.p_mode=param.p_mode;
			if(param.orderinfo!=undefined)
				this.orderinfo=param.orderinfo;
			if(param.syscol!=undefined)
				this.syscol=param.syscol;
			this.setlist=[];
			this.loadlanguage();
		},
		loadlanguage(){
			var that=this;
			this.$public.GetLanguageByMode('transportmain',this).then(res=>{
				if(res.state=='1')
					that.transportmain_lang=that.$lang.label.transportmain;
				that.getsetlist();
			});
		},
		getsetlist(){
			var that=this;
			//debugger
			this.$apipost.get.GetPagecolSet({syscol:this.syscol,l_mode:this.type+'-'+this.p_mode}).then(res => {
				if(res.length>0){
					res.forEach(e=>{
						if(e.controltype.indexOf('disabled')>-1)
							e.isedit=true;
						else
							e.isedit=false;
					});
					var showname='';
					res.forEach(e=>{
						showname=e.showname.replace('/ /g','');
						if(that.transportmain_lang[showname]!=undefined)
							e.showname=that.transportmain_lang[showname];
					});
					if(that.setlist.length>0)
						that.setlist=that.setlist.concat(res);
					else
						that.setlist=res;
		
					if(that.orderinfo!=''){
						that.setlist.forEach(item => {
							var orderinfo=that.orderinfo[item.colkey];
							if(item.combox!=undefined){
								item.combox.forEach(com=>{
									if(com.controlcombox!=undefined){
										if(orderinfo[item.colname]!=undefined){
											var list=JSON.parse(orderinfo[item.colname]);
											var i=0;
											list.forEach(li=>{
												if(i==0){
													com.controlcombox.forEach(box=>{
														if(li[box.colname]!=undefined){
															box.value=li[box.colname];
														}
													});
												}
												else{
													var copycombox=JSON.parse(JSON.stringify(com.controlcombox));
													copycombox.forEach(box=>{
														if(li[box.colname]!=undefined){
															box.value=li[box.colname];
														}
													});
													item.combox.push({controlcombox:copycombox});
												}
												i++;
											});
										}
									}else{
										if(orderinfo[com.colname]!=undefined)
											com.value=orderinfo[com.colname];
									}
								});
							}
							else{
								//debugger
								if(orderinfo[item.colname]!=undefined){
									if((item.controltype=='addedservice_sign-insured'
									||item.controltype=='selectmul')&&orderinfo[item.colname]!=''){
										//debugger
										item.value=JSON.parse(orderinfo[item.colname]);
										if(item.controltype=='addedservice_sign-insured'){
											item.value.forEach(it=>{
												that.checkchange(it.ischecked,'',item,0,it);
											});
										}
									}
									else
										item.value=orderinfo[item.colname];
								}
							}
							if(item.controltype=='disabled_billid')
							{
								if(item.value=='')
								{
									item.coldefault=new Date().getTime();
									item.value=item.coldefault.toString();
								}else{
									that.isedit=false;
								}
							}
						});
					}else{
						that.setlist.forEach(item => {
							if(item.controltype=='disabled_billid') 
							{
								item.coldefault=new Date().getTime();
								item.value=item.coldefault.toString();
							}
							if(item.controltype=='addedservice_sign-insured')
							{
								if(item.colformat!=undefined)
									item.value=item.colformat;
							}
							if(item.colname=='p_mode')
								item.value=that.p_mode;
							if(item.controltype=='selectmul'){
								if(item.colfun=='default_currentaccount'){
									item.value=[localStorage.getItem('u_account')];
								}
							}	
						});
					}
				}
			});
		},
		enterinput(event, i) {
			//debugger
			if (event.keyCode != undefined) {
				if (event.keyCode == 13 || event.keyCode == 39) {
					if (i.colnext != '') {
						if(this.$refs[i.colnext]!=undefined)
								this.$refs[i.colnext][0].focus();
					}
				} else if (event.keyCode == 37) {
					if (i.colperv != ''){
						 if(this.$refs[i.colperv]!=undefined)
							this.$refs[i.colperv][0].focus();
					}
				}
			}
		},
		editinput(i){
			i.isedit=false;
			var that=this;
			this.$nextTick(function() {
				that.$refs[i.colname][0].focus();
			});
		},
		//文本框输入时自动提示
		inputsuggestions(querystring, cb, i, modelindex) {
			//console.log(i);
			var that=this;
			if(i.colevent=='getcrmlist'){
				if(i.value!=''){
					//console.log('输入框 '+i.value);
					//setTimeout(function(){
						that.$tool.crmlist_call(that, i, cb);
					//},1000)
				}
				else
					this.$tool.crmlist_call(this, i, cb);
			}
		},
		select_change(val, i){
			//debugger
			if(i.colevent=="getcrmlist"){
				if(val.band_u_account!=undefined){
					this.transportmainrollback({value:val.band_u_account,colfun:i.colfun},i.colevent);
				}
			}
		},
		clearinput(e){
			debugger
			
		},
		//文本框改变
		text_change(val, i) {
			//debugger
			var that=this;
			if(i.colevent=='changepmode'){
				if(val!='')
					this.transportmainrollback(i,i.colevent);
			}
			if(i.colevent.indexOf('showandhidecontrol')>-1){
				//debugger
				var control=i.colevent.substring(i.colevent.indexOf('(')+1,i.colevent.indexOf(')'));
				if(control!=''){
					if(i.colsource.length>0){
						var list=i.colsource.filter(function(e){
							return e.title==val;
						});
						if(list.length>0){
							var ishidden='False';
							list.forEach(e=>{
								if(e.d_value=='0')
									ishidden='True';
								else
									ishidden='False';
								that.setlist.forEach(item => {
									if(item.colname==control){
										item.ishidden =ishidden;
										if(ishidden=='True'){
											if(item.combox!=undefined){
												var idx=0;
												item.combox.forEach(com=>{
													if(idx==0){
														if(com.controlcombox!=undefined){
															com.controlcombox.forEach(b=>{
																b.value='';
															});
														}
													}
													idx++;
												});
												if(idx>0)
													item.combox.splice(1,idx-1);
											}
										}
									}
								});	
							});
						}
					}
				}
			}
		},
		checkinput(event, i) {
			
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		transportmainrollback(e,fun){
			//切换类型的时候显示
			if(fun=='changepmode'){
				if(e.value!=this.p_mode)
					this.$emit('transportmainrollback',{event:'change',value:e.value});
			}
			else if(fun=='getcrmlist'){
				this.$emit('transportmainrollback',{event:fun,value:e.value,colfun:e.colfun});
			}
		},
		//带搜索的输入框
		inputgroupsearch(i,index) {
			var that=this;
			if(i.colevent=='select_baojia'){
				//获取可用的报价编号
				this.$tool.GetBaojiaNo(this).then(res => {
					if(res.state=='1'){
						if(res.list.length>0){
							this.$nextTick(function(){
								var list=[];
								res.list.forEach(e=>{
									list.push({value:e.p_no,title:e.p_no+' '+e.cname})
								});
								this.$refs.selectitem.init(
								{fun:'getbaojia',
								selectitem:list,
								title:that.transportmain_lang.selectbaojiaowintitle,
								label:that.transportmain_lang.selectbaojiaolabel
								});
							});
						}
					 }else
						 this.$tool.message(that.transportmain_lang.nobj, "0");
					}).catch(e=>{
					});
			}
		},
		selectitemcallback(e){
			if(e.fun=='getbaojia'){
				//debugger
				//读取报价单信息，包含主表信息，费用明细
				this.$emit('transportmainrollback',{event:e.fun,value:e.value});
			}
		},
		addcombox(combox){
			//debugger
			var obj=JSON.parse(JSON.stringify(combox[combox.length-1]));
			obj.controlcombox.forEach(e=>{
				e.value='';
			})
			combox.push(obj);
		},
		removecombox(combox,i){
			combox.splice(i,1);
		},
		checkchange(val, controlid, i,index,currentchild){
			debugger
			if(currentchild.value=='showcargo'){
				this.$emit('transportmainrollback',{event:currentchild.value,value:val});
			}
		}
	}
}
</script>

<style>
</style>
